<template>
    <div v-if="member != null && checkLiveAuction">
        <div v-if="checkAuctionCompany">
            <button
                data-toggle="modal" data-target="#modalCancelPermission"
                class="btn btn-danger-small btn-live d-flex align-items-center justify-content-center ">
                <img src="/img/home/icon-live.svg" class="mr-1 text-live-mobile">
                <div>LIVE <span>会場<span class="text-live-mobile">はこちら</span></span></div>
                <img src="/img/home/icon-arrow-right.svg" class="ml-1">
            </button>
        </div>
        <div v-else>
            <button v-if="memberRank && memberRank.id == 9"
                    data-toggle="modal" data-target="#modalCancelBid"
                    class="btn btn-danger-small btn-live d-flex align-items-center justify-content-center ">
                <img src="/img/home/icon-live.svg" class="mr-1 text-live-mobile">
                <div>LIVE <span>会場<span class="text-live-mobile">はこちら</span></span></div>
                <img src="/img/home/icon-arrow-right.svg" class="ml-1">
            </button>
            <a type="button" v-else-if="checkPermissionAuction"
               class="btn btn-danger-small btn-live d-flex align-items-center justify-content-center "
               v-bind:href="checkAuctionCompany ? '#' : '/auction/live'">
                <img src="/img/home/icon-live.svg" class="mr-1 text-live-mobile">
                <div>LIVE <span>会場<span class="text-live-mobile">はこちら</span></span></div>
                <img src="/img/home/icon-arrow-right.svg" class="ml-1">
            </a>
            <button data-toggle="modal" data-target="#modalConfirmBid" v-else
                    class="btn btn-danger-small btn-live d-flex align-items-center justify-content-center">
                <img src="/img/home/icon-live.svg" class="mr-1 text-live-mobile">
                <div>LIVE <span>会場<span class="text-live-mobile">はこちら</span></span></div>
                <img src="/img/home/icon-arrow-right.svg" class="ml-1">
            </button>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {

    },
    async created() {
        await this.getDataLiveAuction();

        Echo.channel('auction.live')
            .listen('.auction.live', (e) => {
                this.getDataLiveAuction();
            });
    },
    data: function () {
        return {
            member: null,
            memberRank: null,
            checkLiveAuction: null,
            checkAuctionCompany: null,
            checkPermissionAuction: null
        }
    },
    methods: {
        async getDataLiveAuction() {
            await axios.post('/bid/get-data-check-live')
                .then(response => {
                    this.member = response.data.member;
                    this.memberRank = response.data.memberRank;
                    this.checkLiveAuction = response.data.checkLiveAuction;
                    this.checkAuctionCompany = response.data.checkAuctionCompany;
                    this.checkPermissionAuction = response.data.checkPermissionAuction;
                })
                .catch(error => {

                })
        },
    },
}
</script>
